const AZ_FUNCTION_URL =
  "https://tesalo-scan-upload-func-cdt.azurewebsites.net/api";

export const config = { AZ_FUNCTION_URL };
